module.exports = __webpack_public_path__ + "img/support-ico.999d0443.svg";